import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { isPlatformOperator } from "../utils/authUtils";

/**
 * Frontend-side mirror of the backend's `@PreAuthorize("@access.isPlatformOperator()")`
 * (UX only — the backend still enforces this independently on every
 * request). Distinct from {@link SuperAdminRoute}: this is for pages that
 * are genuinely cross-tenant (every institute, not the caller's own) — see
 * `AccessService.isPlatformOperator` javadoc for the audit that established
 * this distinction from a single institute's own `user.superAdmin`.
 */
export default function PlatformOperatorRoute({ children, ...rest }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={() => {
        if (!user) {
          return <Redirect to="/login" />;
        }
        return isPlatformOperator(user) ? children : <Redirect to="/dashboard" />;
      }}
    />
  );
}
